import React from 'react';
import './CnnHeadlines.css';

const CnnHeadlines = ({ articles }) => {
  if (articles.length === 0) return null;

  return (
    <div className="cnn-headlines">
      <div className="cnn-header">
        <span className="cnn-badge">CNN</span>
        <h3 className="cnn-title">Headlines</h3>
      </div>
      <div className="cnn-list">
        {articles.map((article, index) => (
          <a
            key={index}
            href={article.link}
            target="_blank"
            rel="noopener noreferrer"
            className="cnn-item"
          >
            <div className="cnn-item-number">{index + 1}</div>
            <div className="cnn-item-content">
              <h4 className="cnn-item-title">{article.title}</h4>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default CnnHeadlines;
